import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchEmployerActiveSubscription } from "./EmployerActiveSubscriptionAPI";

const initialState = {
    data: [],
    loading: false,
    error: null,
};

export const fetchEmployerActiveSubscriptionAsync = createAsyncThunk("EmployerActiveSubscription/fetch",
    async (_, { rejectWithValue }) => {
        try {

            const data = await fetchEmployerActiveSubscription()
            const resp = data.response;
            // console.log("data's response", data.response);
            return resp;
        } catch (error) {
            return rejectWithValue(error.message)
        }

    }
)

const EmployerActiveSubscriptionSlice = createSlice({
    name: "EmployerActiveSubscription",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchEmployerActiveSubscriptionAsync.pending, (state) => {
                state.loading = true
                state.error = null

            })
            .addCase(fetchEmployerActiveSubscriptionAsync.fulfilled, (state, action) => {
                state.loading = false
                state.data = action.payload;
                state.error = null

            })
            .addCase(fetchEmployerActiveSubscriptionAsync.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;

            })
    }
})

export const selectEmployerActiveSubscription = (state) => state.employerActiveSubscription.data

export default EmployerActiveSubscriptionSlice.reducer